<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="about-container">
				<div class="about-header">
					<h1>关于我们</h1>
					<p>专业的游戏账号租赁平台</p>
				</div>
				
				<div class="about-content">
					<div class="about-section">
						<h2>平台介绍</h2>
						<p>KK账号网是国内专业的游戏账号租赁服务平台，致力于为广大游戏玩家提供安全、便捷、高效的账号租赁服务。我们秉持"诚信为本、用户至上"的理念，通过严格的风控体系和完善的服务流程，确保每一位用户都能享受到优质的租赁体验。</p>
					</div>
					
					<div class="about-section">
						<h2>我们的优势</h2>
						<ul class="advantage-list">
							<li><strong>安全可靠</strong>：严格的账号审核机制，完善的交易保障，让您的租赁无后顾之忧</li>
							<li><strong>快速响应</strong>：7×24小时客服在线，及时解决您遇到的各种问题</li>
							<li><strong>丰富资源</strong>：涵盖主流游戏海量的优质账号，满足不同玩家的需求</li>
							<li><strong>价格透明</strong>：明码标价，无任何隐形消费，让您放心消费</li>
						</ul>
					</div>
					
					<div class="about-section">
						<h2>服务宗旨</h2>
						<p>我们始终坚持"让游戏更简单"的服务宗旨，为玩家提供一站式的账号租赁解决方案。无论是寻找高等级账号体验新游戏，还是短期租号完成特定任务，我们都能为您提供满意的服务。</p>
					</div>
					
					<div class="about-section">
						<h2>联系我们</h2>
						<ul class="contact-list">
							<li>客服时间：周一至周日 8:00-24:00</li>
							<li>官方网站：kkzh.com</li>
							<li>服务理念：用心服务每一位用户</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	data() {
		return {
		}
	},
	created: function () {
	},
	methods: {
	}
}
</script>

<style scoped>
.about-container {
	max-width: 900px;
	margin: 0 auto;
	padding: 40px 20px;
}

.about-header {
	text-align: center;
	margin-bottom: 50px;
	padding-bottom: 30px;
	border-bottom: 1px solid #eee;
}

.about-header h1 {
	font-size: 36px;
	color: #333;
	margin-bottom: 15px;
	font-weight: bold;
}

.about-header p {
	font-size: 18px;
	color: #666;
}

.about-section {
	margin-bottom: 40px;
}

.about-section h2 {
	font-size: 24px;
	color: #333;
	margin-bottom: 20px;
	padding-left: 15px;
	border-left: 4px solid #409EFF;
	font-weight: bold;
}

.about-section p {
	font-size: 16px;
	line-height: 2;
	color: #666;
	text-align: justify;
}

.advantage-list {
	list-style: none;
	padding: 0;
}

.advantage-list li {
	font-size: 16px;
	line-height: 2;
	color: #666;
	padding: 10px 0;
	padding-left: 25px;
	position: relative;
}

.advantage-list li::before {
	content: "•";
	position: absolute;
	left: 10px;
	color: #409EFF;
	font-size: 20px;
}

.advantage-list li strong {
	color: #333;
}

.contact-list {
	list-style: none;
	padding: 0;
}

.contact-list li {
	font-size: 16px;
	line-height: 2;
	color: #666;
	padding: 8px 0;
}
</style>
